export enum LoginMode {
  Regular = 'regular',
  Sso = 'sso',
  Otp = 'otp',
  DeactivateOtp = 'deactivate-otp'
}

export type LoginModeType = LoginMode
